import React, {Component} from "react";
import {Button, Card, CircularProgress, FormControlLabel, FormGroup, Grid, withStyles, Typography} from "@material-ui/core";
import {TextValidator, ValidatorForm} from "react-material-ui-form-validator";
import {withRouter} from "react-router-dom";
import axios from "axios";
import {withSnackbar} from 'material-ui-snackbar-provider';
import {withTranslation} from 'react-i18next';
import Select from 'react-select';
import i18n from "i18next";


import customConstants from "Constants";
import { listAllRoleGroups } from "../../services/RoleGroupService";

let _this;

const styles = theme => ({
    wrapper: {
        position: "relative",
        backgroundColor: '#fff'
    },

    buttonProgress: {
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12
    },
});


class CreateUser extends Component {
    constructor() {
        super();
        this.state = {
            name: "",
            email: "",
            phone: "",
            surname: "",
            externalId: "",
            loading: false,
            roleGroupId: "",
            roleGroups: [],
            checkerUsername: "",
            availableCheckers: [],
            fetchingData: false
        };

        _this = this;
    }


    handleChange = event => {
        event.persist();
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    handleRoleGroupChange = selectedOption => {
        this.setState({"roleGroupId": selectedOption ? selectedOption.value : ""});
    };

    handleCheckerChange = selectedOption => {
        this.setState({"checkerUsername": selectedOption ? selectedOption.value : ""});
    };

    handleFormSubmit = () => {
        if (this.state.name === '' || this.state.email === '' || this.state.surname === '' || !this.state.roleGroupId || !this.state.checkerUsername) {
            this.props.snackbar.showMessage(this.props.t("Please enter all fields correctly"), 'warning');
            return;
        }
        this.setState({loading: true});
        
        const entity = {
            "username": this.state.email,
            "name": this.state.name,
            "surname": this.state.surname,
            "mobile": this.state.phone,
            "language": i18n.language,
        };
        
        if (this.state.externalId) {
            entity.externalId = this.state.externalId;
        }
        
        // Add roleGroupId (XOR rule: either roles OR roleGroupId, not both)
        entity.roleGroupId = this.state.roleGroupId;
        
        axios.post(customConstants.API_URL + "/assess/create-approval-request", {
            "requestType": "USER_CREATE",
            "entity": entity,
            "checkerUsername": this.state.checkerUsername
        }).then((res) => {
            this.setState({
                name: "",
                email: "",
                surname: "",
                phone: "",
                roleGroupId: "",
                checkerUsername: "",
                loading: false,
                externalId: "",
            })
            if (res.status >= 200 && res.status < 300) {
                this.props.snackbar.showMessage(this.props.t("Operation Completed"), 'success');
            } else {
                this.props.snackbar.showMessage(this.props.t("Could not create user"), 'error');
            }
        }).catch((error) => {
            this.setState({loading: false})
            const errorMessage = error.response?.data?.message || this.props.t("Server Error");
            this.props.snackbar.showMessage(errorMessage, 'error');
        })
    };

    componentDidMount() {
        this.fetchRoleGroups();
        this.fetchCheckers();
    }

    fetchRoleGroups = () => {
        this.setState({fetchingData: true});
        listAllRoleGroups()
            .then((response) => {
                const roleGroupsData = Array.isArray(response.data)
                    ? response.data
                    : (response.data && response.data.roleGroups ? response.data.roleGroups : []);

                const roleGroupOptions = roleGroupsData
                    .filter(item => item.roleGroup && item.roleGroup.status === 'ACTIVE')
                    .map(item => ({
                        value: item.roleGroup.roleGroupId,
                        label: item.roleGroup.roleGroupName
                    }));

                this.setState({
                    roleGroups: roleGroupOptions,
                    fetchingData: false
                });
            })
            .catch((error) => {
                console.error('Error fetching role groups:', error);
                this.setState({fetchingData: false});
                this.props.snackbar.showMessage(this.props.t("Couldn't fetch role groups"), 'error');
            });
    }

    fetchCheckers = () => {
        // Get current user from localStorage
        let currentUsername = '';
        try {
            const authUser = localStorage.getItem('auth_user');
            if (authUser) {
                const userData = JSON.parse(authUser);
                currentUsername = userData.email || userData.username || '';
            }
        } catch (e) {
            console.error('Error getting current user:', e);
        }

        axios.get(customConstants.API_URL + '/user/list')
            .then((response) => {
                if (response.data && Array.isArray(response.data)) {
                    const checkers = response.data
                        .filter(user => {
                            // Exclude current user
                            if (currentUsername && (user.username === currentUsername || user.email === currentUsername)) {
                                return false;
                            }
                            // Filter users who have checker role
                            const roles = Array.isArray(user.roles) ? user.roles : [];
                            return roles.some(role => {
                                const roleStr = typeof role === 'string' ? role : (role.roleName || role.name || '');
                                return roleStr && roleStr.toLowerCase().includes('checker');
                            });
                        })
                        .map(user => ({
                            value: user.username,
                            label: `${user.name || ''} ${user.surname || ''} (${user.username})`.trim() || user.username
                        }));

                    // If nothing left (only current user is checker), fall back to include current user
                    if (checkers.length === 0) {
                        const fallbackCheckers = response.data
                            .filter(user => {
                                const roles = Array.isArray(user.roles) ? user.roles : [];
                                return roles.some(role => {
                                    const roleStr = typeof role === 'string' ? role : (role.roleName || role.name || '');
                                    return roleStr && roleStr.toLowerCase().includes('checker');
                                });
                            })
                            .map(user => ({
                                value: user.username,
                                label: `${user.name || ''} ${user.surname || ''} (${user.username})`.trim() || user.username
                            }));
                        this.setState({availableCheckers: fallbackCheckers});
                    } else {
                        this.setState({availableCheckers: checkers});
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching checkers:', error);
            });
    }

    render() {
        let {name, email, surname, phone, externalId, roleGroupId, checkerUsername} = this.state;
        let {classes} = this.props;

        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                zIndex: 99999999
            }),
            container: (provided, state) => ({
                ...provided,
                backgroundColor: 'transparent',
                zIndex: 99999999
            }),
            control: (provided, state) => ({
                ...provided,
                backgroundColor: 'transparent',
                padding: '5px 0'
            }),
            singleValue: (provided, state) => {
                const opacity = state.isDisabled ? 0.5 : 1;
                const transition = 'opacity 300ms';
                return {...provided, opacity, transition};
            },
            menuPortal: (provided) => ({
                ...provided,
                zIndex: 9999
            })
        }

        return (
            <div className="signup flex flex-center w-100 h-100vh" style={{backgroundColor: '#021633'}}>
                <div className="p-8">
                    <Card className="signup-card position-relative y-center" style={{backgroundColor: '#092A5C'}}>
                        <Grid container>
                            <Grid item lg={5} md={5} sm={5} xs={12}>
                                <div className="p-32 flex flex-center flex-middle h-100">
                                    <img src="/assets/images/logos/proveid.svg" alt=""/>
                                </div>
                            </Grid>
                            <Grid item lg={7} md={7} sm={7} xs={12} style={{backgroundColor: '#fff'}}>
                                <div className="p-36 h-100 bg-light-gray position-relative">
                                    <h3 style={{marginBottom: "20px"}}>{this.props.t("Create User")}</h3>
                                    <ValidatorForm ref="form" onSubmit={this.handleFormSubmit}>
                                        <div style={{flexDirection: 'row', display: 'flex', gap: 10, width: '100%'}}>
                                            <TextValidator
                                                className="mb-16 w-100 d-flex"
                                                label={this.props.t("Name")}
                                                variant="outlined"
                                                onChange={this.handleChange}
                                                name="name"
                                                type="text"
                                                value={name}
                                                validators={["required"]}
                                                errorMessages={["this field is required"]}
                                            />
                                            <TextValidator
                                                className="mb-16 w-100 d-flex"
                                                label={this.props.t("Surname")}
                                                variant="outlined"
                                                onChange={this.handleChange}
                                                name="surname"
                                                type="text"
                                                value={surname}
                                                validators={["required"]}
                                                errorMessages={["this field is required"]}
                                            />
                                        </div>

                                        <TextValidator
                                            className="mb-16 w-100"
                                            label={this.props.t("E-mail")}
                                            variant="outlined"
                                            onChange={this.handleChange}
                                            name="email"
                                            type="email"
                                            value={email}
                                            validators={['required', 'isEmail']}
                                            errorMessages={['this field is required', 'email is not valid']}
                                        />
                                        <div style={{flexDirection: 'row', display: 'flex', gap: 10, width: '100%'}}>
                                            <TextValidator
                                                className="mb-16 w-100"
                                                label={this.props.t("Phone")}
                                                variant="outlined"
                                                onChange={this.handleChange}
                                                name="phone"
                                                type="text"
                                                placeholder="5554443322"
                                                value={phone}
                                                validators={['required', 'matchRegexp:^5[0-9]{9}$']}
                                                errorMessages={['this field is required', 'phone is not valid']}
                                            />
                                            <TextValidator
                                                className="mb-16 w-100"
                                                label={this.props.t("External Id")}
                                                variant="outlined"
                                                onChange={this.handleChange}
                                                name="externalId"
                                                type="text"
                                                placeholder="1234567890"
                                                value={externalId}
                                            />
                                        </div>
                                        <div style={{marginBottom: '16px'}}>
                                            <Typography style={{ fontWeight: 600, marginBottom: '8px' }}>
                                                {this.props.t('Role Group')} *
                                            </Typography>
                                            {this.state.fetchingData ? (
                                                <CircularProgress size={24} />
                                            ) : (
                                                <Select
                                                    className="mb-16 w-100"
                                                    value={this.state.roleGroups.find(rg => rg.value === roleGroupId) || null}
                                                    onChange={this.handleRoleGroupChange}
                                                    options={this.state.roleGroups}
                                                    styles={customStyles}
                                                    placeholder={this.props.t('Select role group')}
                                                    menuPortalTarget={document.body}
                                                    isClearable
                                                />
                                            )}
                                            {this.state.roleGroups.length === 0 && !this.state.fetchingData && (
                                                <Typography variant="caption" color="textSecondary">
                                                    {this.props.t('No role groups available. Please create role groups first.')}
                                                </Typography>
                                            )}
                                        </div>
                                        <div style={{marginBottom: '16px'}}>
                                            <Typography style={{ fontWeight: 600, marginBottom: '8px' }}>
                                                {this.props.t('Checker Username')} *
                                            </Typography>
                                            {this.state.availableCheckers.length > 0 ? (
                                                <Select
                                                    className="mb-16 w-100"
                                                    value={this.state.availableCheckers.find(c => c.value === checkerUsername) || null}
                                                    onChange={this.handleCheckerChange}
                                                    options={this.state.availableCheckers}
                                                    styles={customStyles}
                                                    placeholder={this.props.t('Select checker')}
                                                    menuPortalTarget={document.body}
                                                    isClearable
                                                    isSearchable
                                                />
                                            ) : (
                                                <TextValidator
                                                    className="mb-16 w-100"
                                                    label={this.props.t('Checker Username')}
                                                    variant="outlined"
                                                    onChange={this.handleChange}
                                                    name="checkerUsername"
                                                    type="text"
                                                    value={checkerUsername}
                                                    validators={["required"]}
                                                    errorMessages={["this field is required"]}
                                                />
                                            )}
                                        </div>
                                        <div className="flex flex-middle" style={{marginTop: 20, marginBottom: 30}}>
                                            <div className={classes.wrapper} style={{width: "100%"}}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    type="submit"
                                                    disabled={this.state.loading}
                                                    style={{width: "100%"}}
                                                >
                                                    {this.props.t("Create")}
                                                </Button>
                                                {this.state.loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={classes.buttonProgress}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div style={{textAlign: 'center', marginBottom: 40}}><a href={'#'}
                                                                                                onClick={() => this.props.history.push("/")}>{this.props.t("Back To Panel")}</a>
                                        </div>
                                    </ValidatorForm>
                                </div>
                            </Grid>
                        </Grid>
                    </Card>
                </div>
            </div>
        );
    }
}

export default withTranslation()(withStyles(styles, {withTheme: true})(withSnackbar()(withRouter(
    CreateUser
))));
